<!-- brain evolved assessment branding -->
<ion-row class="brand-name ion-justify-content-center">
  <ion-col size="12">    
    <span class="bold color-white">{{ appTitle }} by Brain Evolved</span>    
  </ion-col>
</ion-row>
<!-- brain evolved assessment branding /-->
